<template>
  <div class="home">
    <div class="big-banner">
      <div class="big-text">
        <p>神奇管家</p>
        <p><span>零信任</span>安全准入，<span>无边界</span>高效办公</p>
      </div>
      <div class="small-text">*支持 Mac Apple M1/M2、Mac Intel及Windows 10.0以上版本</div>
      <div class="button-group">
        <div class="button" @click="openMacType" title="Mac OS客户端">
          <i class="icon mac"></i>
          <div class="main">
            <span class="type">Mac OS客户端</span>
            <span class="version">版本：{{mac_new_version}}</span>
          </div>
        </div>
        <a :href="win_download_url" download=""  class="button" title="Windows客户端">
          <i class="icon windows"></i>
          <div class="main">
            <span class="type">Windows客户端</span>
            <span class="version">版本：{{win_new_version}}</span>
          </div>
        </a>
      </div>
    </div>
    <div class="container-wrapper">
      <div class="container-box">
        <div class="big-title">安全办公&nbsp;&nbsp;&nbsp;助力提效</div>
        <div class="classes-box">
          <div class="item">
            <i class="icon1"></i>
            <span class="text">零信任准入</span>
          </div>
          <div class="item">
            <i class="icon2"></i>
            <span class="text">无边界办公</span>
          </div>
          <div class="item">
            <i class="icon3"></i>
            <span class="text">安全防护</span>
          </div>
          <div class="item">
            <i class="icon4"></i>
            <span class="text">终端管理</span>
          </div>
          <div class="item">
            <i class="icon5"></i>
            <span class="text">软件中心</span>
          </div>
          <div class="item">
            <i class="icon6"></i>
            <span class="text">IT服务</span>
          </div>
          <div class="item">
            <i class="icon7"></i>
            <span class="text">常用工具</span>
          </div>
          <div class="item">
            <i class="icon8"></i>
            <span class="text">站点导航</span>
          </div>
          <div class="item">
            <i class="icon9"></i>
            <span class="text">个人中心</span>
          </div>
        </div>
      </div>
      <div class="info-box" style="margin-top:120px;">
        <div class="main pl80">
          <div class="title">零信任网络准入</div>
          <div class="content">基于“零信任”理念，集成身份认证机制，统一管理多终端<br>设备的网络接入与授权</div>
        </div>
        <div class="banner b1" style="margin-right:40px;"></div>
      </div>
      <div class="info-box">
        <div class="banner b2" style="margin-left:30px;"></div>
        <div class="main pl100">
          <div class="title">无边界办公</div>
          <div class="content">无论身处何地，均可一键连接办公环境，内网稳定接入，安全、便捷、高效</div>
        </div>
        
      </div>
      <div class="info-box">
        <div class="main pl80">
          <div class="title">软件中心</div>
          <div class="content">常用办公软件，纯净无捆绑，便捷升级，卸载无残留</div>
        </div>
        <div class="banner b3" style="margin-right:40px;"></div>
      </div>
      <div class="info-box">
        <div class="banner b4" style="margin-left:40px;"></div>
        <div class="main pl100">
          <div class="title">IT服务</div>
          <div class="content">办公问题快问速答，关联自动化工具一键搞定网络、系统、电话等问题，IT专家进行在线支持和远程协助！</div>
        </div>
        
      </div>
      <div class="info-box">
        <div class="main pl80">
          <div class="title">常用工具</div>
          <div class="content">聚焦日常工作问题反馈，优化终端使用，一众常用工具<br>触手可及，提升工作效率</div>
        </div>
        <div class="banner b5" style="margin-right:40px;"></div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="1200px"
      :before-close="closeMacType"
      class="dialog-box"
      top="10vh"
      >
     <div class="dialog-title">你的mac是哪个版本？</div>
     <div class="dialog-content">
      如何确认芯片类型?<br>
1. 在左上角， 点击 <span class="bold">Apple 菜单 > 关于本机</span><br>
2. 在<span class="bold">概览</span>标签页中，寻找<span class="bold">处理器或芯片</span>，确认显示的是"Apple"还是"Intel"
     </div>
     <div class="dialog-images">
        <div class="img1"></div>
        <div class="img2"></div>
        <div class="img3"></div>
     </div>
     <div class="dialog-download">
      <a :href="mac_arm_download_url" download="" class="button" title="Apple芯片版下载">Apple芯片版下载</a>
      <a :href="mac_intel_download_url " download="" class="button" title="Intel芯片版下载">Intel芯片版下载</a>
     </div>
    </el-dialog>
  </div>
</template>

<script>
import appVersionListService from "../api/service/appVersionListService";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      mac_intel_download_url: "",
      mac_arm_download_url: "",
      win_download_url: "",
      mac_new_version: "--",
      win_new_version: "--",
      dialogVisible: false,
    };
  },
  watch: {},
  mounted() {
    this.downloadApp();
  },
  methods: {
   
    downloadApp: async function () {
      let res = await appVersionListService.downloadAppVersion({});
      const result = JSON.parse(res.data);
      if (200 === res.status) {
        let errorCode = result.code;
        if (errorCode === 0) {
          let data = result.data;
          data.find((item) => {
            if (item["app_type"] === "arm64") {
              this.mac_new_version = item["version"];
              this.mac_arm_download_url = item["file_url"];
            }
            if (item["app_type"] === "intel") {
              this.mac_intel_download_url = item["file_url"];
            }
            if (item["app_type"] === "Windows") {
              this.win_new_version = item["version"];
              this.win_download_url = item["file_url"];
            }
          })
          
        }else{
          this.$message.error(result.message);
        } 
      } else {
       this.$message.error("抱歉，接口异常！");
      }
    },
    openMacType() {
      this.dialogVisible = true;
    },
    closeMacType() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-banner{
  .big-text{
    padding-top:70px;
    p{
      font-size:56px;
      // font-weight: 300;
      text-align: center;
      color:#000;
      line-height :90px;
      span{
        color:#4062ea;
        font-size:56px;
      }
    }
    
  }
  .small-text{
      color:#999;
      font-size:16px;
      // font-weight: 300;
      background: #fff;
      height:32px;
      line-height:32px;
      border-radius: 16px;
      text-align: center;
      width:480px;
      margin:40px auto;
      box-shadow: 0 0 20px rgba(82, 82, 82, 0.1);
    }
    .button-group{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top:130px;
      .button{
        display: flex;
        justify-content: center;
        align-items: center;
        width:260px;
        height:70px;
        background: #4062ea;
        color:#fff;
        border-radius: 35px;
        cursor: pointer;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        &:last-child{
          margin-left:60px;
        }
        &:hover{
          background: #1337d0;
        }
        .icon{
          display: block;
          width:36px;
          height:36px;
          &.mac{
            width:30px;
            height:30px;
            background: url("../assets/images/v3_mac.png") no-repeat center;
            background-size: 100% auto;
            margin-right:20px;
          }
          &.windows{
            background: url("../assets/images/v3_windows.png") no-repeat center;
            background-size: 100% auto;
            margin-right:15px;
          }
        }
        .type{
          font-size:18px;
          // font-weight: 300;
        }
        .version{
          display: block;
          font-size:14px;
          // font-weight: 300;
          margin-top:3px;
        }
      }
    }
}
.container-wrapper {
  .big-title {
    margin-top:180px;
    height: 40px;
    line-height: 40px;
    font-size: 36px;
    // font-weight: 300;
    text-align: center;
  }
  .classes-box{
    display: flex;
    justify-content: center;
    margin-top:60px;
    .item{
      width:124px;
      height:136px;
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-right:20px;
      &:last-child{
        margin-right:0;
      }
      i{
        display: block;
        width:36px;
        height:36px;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
        
        &.icon1{
          background-image: url("../assets/images/v3_zero.png");
        }
        &.icon2{
          background-image: url("../assets/images/v3_endless.png");
        }
        &.icon3{
          background-image: url("../assets/images/v3_safe.png");
        }
        &.icon4{
          background-image: url("../assets/images/v3_zhongduan.png");
        }
        &.icon5{
          background-image: url("../assets/images/v3_software.png");
        }
        &.icon6{
          background-image: url("../assets/images/v3_handshake.png");
        }
        &.icon7{
          background-image: url("../assets/images/v3_toolkit.png");
        }
        &.icon8{
          background-image: url("../assets/images/v3_gps.png");
        }
        &.icon9{
          background-image: url("../assets/images/v3_person.png");
        }
      }
      span{
        font-size:16px;
        margin-top:15px;
      }
    }

  }
  .info-box{
    border-radius: 20px;
    background: #F7F9FF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin:50px auto 0;
    width:1280px;
    height:560px;
    // box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    .main{
      // width:40%;
      flex:1;
      flex-shrink:0 ;
      padding-right:60px;
      text-align: left;
      box-sizing: border-box;
      .title{
        font-size: 36px;
        // font-weight: 300;
        color:#000;
        line-height: 40px;
      }
      .content{
        font-size: 16px;
        color:#666;
        line-height:32px;
        margin-top:20px;
      }
    }
    .banner{
      width:660px;
      height:480px;
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
      &.b1{
        background-image: url("../assets/images/v3_banner1.png");
      }
      &.b2{
        background-image: url("../assets/images/v3_banner2.png");
      }
      &.b3{
        background-image: url("../assets/images/v3_banner3.png");
      }
      &.b4{
        background-image: url("../assets/images/v3_banner4.png");
      }
      &.b5{
        background-image: url("../assets/images/v3_banner5.png");
      }
    }
    
  }
  
}
.dialog-box ::v-deep{
  .el-dialog{
    border-radius: 20px!important;
  }
  .el-dialog__body{
    color:#000;
  }
  .dialog-title{
    font-size:30px;
    text-align: center;
    line-height: 60px;
    padding:0 30px;
  }
  .dialog-content{
    font-size:16px;
    line-height: 30px;
    margin-top:20px;
    padding:0 30px;
    .bold{
      font-weight: 500;
      font-size:16px;
    }
  }
  .dialog-images{
    margin-top:30px;
    padding:0 30px;
    display: flex;
    justify-items: center;
    .img1,.img2,.img3{
     display: block;
     width:240px;
     height:160px;
      background-size: 100% auto;
      background-repeat: no-repeat;
      margin-right:25px;
    }
    .img1{
      background-image: url("../../src/assets/images/v3_mactype1.png");
    }
    .img2{
      background-image: url("../../src/assets/images/v3_mactype2.png");
    }
    .img3{
      background-image: url("../../src/assets/images/v3_mactype3.png");
      margin-right:0;
    }
  }
  .dialog-download{
    padding:0 30px 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:50px;
    .button{
      display: block;
      width:220px;
      height: 60px;
      line-height: 60px;
      border-radius: 30px;
      font-size:18px;
      // font-weight: 300;
      cursor: pointer;
      background: #4062ea;
      color:#fff;
      text-align: center;
      &:last-child{
        margin-left:40px;
      }
      &:hover{
        background: #1337d0;
      }
    }
  }
}
.pl80{
  padding-left:80px;
}
.pl100{
  padding-left:100px;
}
</style>
